import React from 'react';
import fr from 'facet-rest';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import HighPriorityActionCard from 'Views/Dashboard/HighPriorityActionCard';
import { AIR_SUBTITLE, AIR_TITLE } from 'Consts/annualReview';

const AnnualReviewCardPicker = (props) => {
  const { householdResource } = useSimpleHousehold();

  return householdResource.withRelationship(
    fr.relationships.annualInvestmentReview.name,
    (rel) => <HighPriorityActionCard relationship={rel} title={AIR_TITLE} subtitle={AIR_SUBTITLE} data-test="air-entry-point" {...props} />,
    () => null,
  );
};

export default AnnualReviewCardPicker;
